import { OwnerType } from "@/domains/inventory/constants/ownerType";

export const ownerTypePriority: Record<OwnerType, number> = {
  [OwnerType.Trade]: 0,
  [OwnerType.Wallet]: 1,
  [OwnerType.VehicleTrunk]: 2,
  [OwnerType.VehicleGloveBox]: 3,
  [OwnerType.GarbageContainer]: 4,
  [OwnerType.Environment]: 5,
  [OwnerType.Bag]: 6,
  [OwnerType.EstateSafe]: 7,
  [OwnerType.Character]: 8,
  [OwnerType.Confiscation]: 9,
};
